import Client from 'shopify-buy';

/**
 *
 * @param {*} digit
 * Pre fix with '0' if the digit below 10
 */

export const preFixZero = digit => {
  return digit < 10 ? ('0' + digit).slice(-2) : digit;
};

export function debounce(callback, wait, immediate = false) {
  let timeout = null;

  return function() {
    const callNow = immediate && !timeout;
    const next = () => callback.apply(this, arguments);

    clearTimeout(timeout);
    timeout = setTimeout(next, wait);

    if (callNow) {
      next();
    }
  };
}

export function throttle(callback, wait, immediate = false) {
  let timeout = null;
  let initialCall = true;

  return function() {
    const callNow = immediate && initialCall;
    const next = () => {
      callback.apply(this, arguments);
      timeout = null;
    };

    if (callNow) {
      initialCall = false;
      next();
    }

    if (!timeout) {
      timeout = setTimeout(next, wait);
    }
  };
}

export const formatPrice = amount => {
  return (amount / 100)
    .toLocaleString('en-US', {
      style: 'currency',
      currency: 'AUD',
    })
    .substr(1);
};

export function copyStringToClipboard(str) {
  // Create new element
  let el = document.createElement('textarea');
  // Set value (string to be copied)
  el.value = str;
  // Set non-editable to avoid focus and move outside of view
  el.setAttribute('readonly', '');
  el.style = { position: 'absolute', left: '-9999px' };
  document.body.appendChild(el);
  // Select text inside element
  el.select();
  // Copy text to clipboard
  document.execCommand('copy');
  // Remove temporary element
  document.body.removeChild(el);
}

const shopifyBuyClient = Client.buildClient({
  domain: 'poliform-au.myshopify.com',
  storefrontAccessToken: 'c11d8c7ace9b4028cfdcc5750e5ee291',
});

const productIdToGid = id => {
  return btoa(`gid://shopify/Product/${id}`);
};

const variantIdToGid = id => {
  return btoa(`gid://shopify/ProductVariant/${id}`);
};

/* export const getProductVariantDetails = async (productId, variantId) => {
  const productGid = productIdToGid(productId);
  console.log('variantId', variantId);
  console.log('productGid', productGid);

  const selectedVariant = await shopifyBuyClient.product
    .fetch(productGid)
    .then(product => {
      // Do something with the product
      console.log('product', product);
      return product;
    })
    .catch(error => {
      console.error('Error:', error);
    });

  console.log('selectedVariant', selectedVariant);
  return selectedVariant;
};
 */
export const getProductVariantDetails = (productId, variantId) => {
  // eslint-disable-next-line no-unused-vars
  return new Promise((resolve, reject) => {
    const variantGid = variantIdToGid(variantId);
    return shopifyBuyClient.product.fetch(productIdToGid(productId)).then(product => {
      const variant = product.variants.find(variant => variant.id === variantGid);
      return resolve({
        ...variant,
        handle: product.handle,
        title: product.title,
        variantId,
      });
    });
  });
};
